<!-- eslint-disable vue/valid-v-slot -->
<template>
  <div class="bonus-page">
    <div class="page-header">
      <div class="page-header-text">
        <h1 class="page-title">Bonusy</h1>
      </div>
    </div>
    <v-data-table
      :headers="headers"
      :items="bonuses"
      class="elevation-1"
      :loading="loading"
      :search="search"
      :options.sync="options"
      :server-items-length="totalItems"
    >
      <template v-slot:top>
        <div class="table-section-title">
          <div class="filter-icon"><v-icon size="18" color="#5478FF">mdi-gift-outline</v-icon></div>
          <div class="filter-title">{{ $t('bonusPage.title') }}</div>
          <v-spacer></v-spacer>
          <button class="action-pill action-pill--primary" @click="((dialog = true), (currentBonusId = null))">
            <v-icon left small>mdi-plus</v-icon>
            {{ $t('common.add') }}
          </button>
        </div>
            <div>
              <v-row class="mx-2">
                <v-col cols="12" md="3">
                  <v-text-field
                    v-model="search"
                    :label="$t('bonusPage.searchLabel')"
                    outlined
                    dense
                    hide-details
                    prepend-inner-icon="mdi-magnify"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="3">
                  <v-menu
                    ref="startDateMenu"
                    v-model="startDateMenu"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                    content-class="dark-date-picker"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="startDate"
                        :label="$t('bonusPage.dateFrom')"
                        outlined
                        dense
                        hide-details
                        readonly
                        clearable
                        prepend-inner-icon="mdi-calendar"
                        v-bind="attrs"
                        v-on="on"
                        @click:clear="clearStartDate"
                      />
                    </template>
                    <v-date-picker
                      v-model="startDate"
                      no-title
                      scrollable
                      @input="startDateMenu = false"
                      first-day-of-week="1"
                      :locale="$i18n.locale"
                    />
                  </v-menu>
                </v-col>
                <v-col cols="12" md="3">
                  <v-menu
                    ref="endDateMenu"
                    v-model="endDateMenu"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                    content-class="dark-date-picker"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="endDate"
                        :label="$t('bonusPage.dateTo')"
                        outlined
                        dense
                        hide-details
                        readonly
                        clearable
                        prepend-inner-icon="mdi-calendar"
                        v-bind="attrs"
                        v-on="on"
                        @click:clear="clearEndDate"
                      />
                    </template>
                    <v-date-picker
                      v-model="endDate"
                      no-title
                      scrollable
                      @input="endDateMenu = false"
                      first-day-of-week="1"
                      :locale="$i18n.locale"
                    />
                  </v-menu>
                </v-col>
                <v-col cols="12" md="3">
                  <v-autocomplete
                    v-model="selectedDriver"
                    :items="drivers"
                    :label="$t('bonusPage.driverLabel')"
                    outlined
                    dense
                    hide-details
                    clearable
                    item-text="name"
                    item-value="id"
                    prepend-inner-icon="mdi-account-search"
                    :no-data-text="$t('common.noResults') || 'Brak wyników'"
                    :menu-props="{ contentClass: 'dark-form-dialog' }"
                    @click:clear="clearDriver"
                  />
                </v-col>
              </v-row>
            </div>
          </template>
          <template v-slot:item.type="{ item }">
            <v-chip x-small dark :color="(item.type === 'NEGATIVE' || item.type === 'RENT') ? 'red' : 'green'">
              {{ item.type === 'NEGATIVE' ? 'Negatywny' : (item.type === 'RENT' ? 'Najem' : 'Pozytywny') }}
            </v-chip>
          </template>
          <template v-slot:item.driver="{ item }">
            <a href="#" @click.prevent="goToDriver(item.driverId)"
               style="text-decoration: underline; cursor: pointer; color: #1976d2;">
              {{ item.driver }}
            </a>
          </template>
          <template v-slot:item.status="{ item }">
            <v-chip
              x-small
              :color="statusColor(item.status)"
              text-color="white"
              class="font-weight-bold"
            >
              {{ statusLabel(item.status) }}
            </v-chip>
          </template>
          <template v-slot:item.details="{ item }">
            <v-btn class="warning" @click="infoBonus(item.id)"
              ><v-icon small class="pt-1">mdi-pencil</v-icon></v-btn
            >
          </template>
          <template v-slot:item.download="{ item }">
        <v-btn class="secondary" @click="downloadFile(item.fileId)">
          {{ $t('bonusPage.downloadFile') }}
        </v-btn>
      </template>
          <template v-slot:item.deleteBonus="{ item }">
            <v-btn class="error" @click="deleteBonus(item.id)"
              ><v-icon small class="pt-1">mdi-delete</v-icon></v-btn
            >
          </template>
        </v-data-table>
    <v-dialog content-class="dark-form-dialog" v-model="dialog" max-width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">{{ $t('bonusPage.bonusForm') }}</span>
        </v-card-title>

        <v-card-text>
          <v-form ref="form" v-model="valid" @submit.prevent="submitBonus">
            <v-row>
              <v-col cols="12">
                <v-file-input
                  v-model="bonus.file"
                  :label="$t('bonusPage.labels.file')"
                  outlined
                  accept="image/*,.pdf, image/*"
                  @change="previewFile"
                />
                <iframe
                  v-if="bonus.preview"
                  :src="bonus.preview"
                  style="width: 100%; height: 400px"
                  frameborder="0"
                ></iframe>
              </v-col>
              <!-- Date -->
              <v-col cols="12" md="6">
                <v-menu
                  ref="dateMenu"
                  v-model="menuDate"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="bonus.date"
                      :label="$t('bonusPage.labels.date')"
                      outlined
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      :rules="[validateRequired]"
                    />
                  </template>
                  <v-date-picker
                    v-model="bonus.date"
                    no-title
                    scrollable
                    @input="menuDate = false"
                    first-day-of-week="1"
                    :locale="$i18n.locale"
                  />
                </v-menu>
              </v-col>

              <!-- Driver -->
              <v-col cols="12" md="6">
                <v-autocomplete
                  v-model="bonus.driverId"
                  :items="drivers"
                  :label="$t('bonusPage.labels.driver')"
                  outlined
                  required
                  clearable
                  :rules="[validateRequired]"
                  item-text="name"
                  item-value="id"
                  prepend-inner-icon="mdi-account-search"
                  :no-data-text="$t('common.noResults') || 'Brak wyników'"
                  :menu-props="{ contentClass: 'dark-form-dialog' }"
                />
              </v-col>

              <!-- Status -->
              <v-col cols="12" md="6">
                <v-select
                  v-model="bonus.status"
                  :items="statusOptions"
                  :label="$t('bonusPage.labels.status')"
                  outlined
                  required
                  :rules="[validateRequired]"
                  @change="onStatusChange"
                />
              </v-col>

              <!-- Status -->
              <v-col cols="12" md="6">
                <v-select
                  v-model="bonus.type"
                  :items="bonusType"
                  :label="$t('bonusPage.labels.type')"
                  outlined
                  required
                  :rules="[validateRequired]"
                />
              </v-col>
              <!-- Return Cost -->
              <v-col cols="12" md="12">
                <v-text-field
                  v-model="bonus.name"
                  :label="$t('bonusPage.labels.description')"
                  outlined
                  required
                  type="text"
                  :rules="[validateRequired]"
                />
              </v-col>
              <!-- Return Cost -->
              <v-col cols="12" md="12">
                <v-text-field
                  v-model.number="bonus.price"
                  :label="$t('bonusPage.labels.amount')"
                  outlined
                  required
                  type="number"
                  :rules="[validateRequired, validatePositiveNumber]"
                />
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>

        <v-card-actions>
                <v-spacer></v-spacer>
          <!-- Cancel Button -->
          <v-btn text color="secondary" @click="dialog = false">{{ $t('common.cancel') }}</v-btn>
          <!-- Submit Button -->
          <v-btn color="primary" :disabled="!valid" @click="submitBonus">
            {{ $t('common.save') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Swal from "sweetalert2";
const axios = require("axios");
import * as dayjs from "dayjs";
export default {
  data() {
    return {
      loading: false,
      dialog: false,
      valid: false,
      menuDate: false,
      search: "",
      startDate: null,
      endDate: null,
      selectedDriver: null,
      startDateMenu: false,
      endDateMenu: false,
      options: {
        page: 1,
        itemsPerPage: 10,
      },
      totalItems: 0,
      originalStatus: null,
      bonus: {
        date: null,
        name: null,
        type: null,
        driverId: null,
        status: null,
        price: null,
        file: null,
        preview: null,
      },
      headers: [
        {
          text: "Data",
          align: "start",
          sortable: false,
          value: "date",
        },
        {
          text: "Kwota",
          align: "start",
          sortable: false,
          value: "price",
        },
        {
          text: "Rodzaj",
          align: "start",
          sortable: false,
          value: "type",
        },
              {
          text: "Opis",
          align: "start",
          sortable: false,
          value: "description",
        },
        {
          text: "Kierowca",
          align: "start",
          sortable: false,
          value: "driver",
        },
        {
          text: "Status",
          align: "start",
          sortable: false,
          value: "status",
        },
        { text: "", value: "details", sortable: false },
        { text: "", value: "download", sortable: false },
        { text: "", value: "deleteBonus", sortable: false },
      ],
      drivers: [],
      statusOptions: [
        { text: "OCZEKUJĄCY", value: "PENDING" },
        { text: "WYPŁATA UTWORZONA", value: "PAYOUT_CREATED" },
        { text: "ZAPŁACONY", value: "PAID" },
      ],
      bonusType: [
        { text: "POZYTYWNY", value: "POSITIVE" },
        { text: "NEGATYWNY", value: "NEGATIVE" },
      ],
      bonuses: [],
    };
  },
  async created() {
    await this.getDriversSelect();
    await this.initialize();
  },
  watch: {
    options: {
      handler() {
        this.initialize();
      },
      deep: true,
    },
    search: {
      handler() {
        this.initialize();
      },
      deep: true,
    },
    startDate: {
      handler() {
        this.initialize();
      },
    },
    endDate: {
      handler() {
        this.initialize();
      },
    },
    selectedDriver: {
      handler() {
        this.initialize();
      },
    },
  },
  methods: {
    statusLabel(status) {
      return ({
        PENDING: 'Oczekujący',
        PAYOUT_CREATED: 'Wypłata utworzona',
        PAID: 'Zapłacony',
      })[status] || status || '—';
    },
    statusColor(status) {
      return ({
        PENDING: 'warning',
        PAYOUT_CREATED: 'info',
        PAID: 'success',
      })[status] || 'grey';
    },
    validateRequired(value) {
      return !!value || "To pole jest wymagane";
    },
    validatePositiveNumber(value) {
      return value >= 0 || "Wartość musi być dodatnia";
    },
    onStatusChange(newStatus) {
      if (this.originalStatus === 'PENDING' && (newStatus === 'PAID' || newStatus === 'PAYOUT_CREATED')) {
        Swal.fire({
          title: "Uwaga!",
          text: "Zmiana statusu z OCZEKUJĄCY na inny spowoduje pominięcie tego bonusu w rozliczeniach.",
          icon: "warning",
          confirmButtonText: "Rozumiem",
        });
      }
    },
    clearStartDate() {
      this.startDate = null;
    },
    clearEndDate() {
      this.endDate = null;
    },
    clearDriver() {
      this.selectedDriver = null;
    },
    goToDriver(id) {
      if (id) location.href = '/driver-details?id=' + id;
    },
    async toggleLoading(type) {
      const toggle = type;
      localStorage.setItem("loading", toggle);
      window.dispatchEvent(
        new CustomEvent("toggleLoading", {
          detail: {
            loading: localStorage.getItem("loading"),
            overlay: localStorage.getItem("loading"),
          },
        })
      );
    },
    previewFile(file) {
      console.log(file);
      if (file && file instanceof File) {
        const reader = new FileReader();
        reader.onload = (e) => {
          console.log(e.target.result);
          this.bonus.preview = e.target.result;
        };
        reader.readAsDataURL(file);
      }
    },
    async downloadFile(fileId) {
        const file = await axios({
          method: "post",
          url: process.env.VUE_APP_ROOT_API + "aws/download-file/" + fileId,
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
          responseType: "blob",
        });
        let blob = new Blob([file.data], { type: file.data.type }),
          url = window.URL.createObjectURL(blob);
        window.open(url);
      
    },
    async deleteBonus(id) {
      Swal.fire({
        title: "Napewno usunąć?",
        text: "",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Tak",
        cancelButtonText: "Anuluj",
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            await axios({
              method: "delete",
              url: process.env.VUE_APP_ROOT_API + "bonuses/" + id,
              headers: {
                Authorization: "Bearer " + localStorage.getItem("token"),
              },
            });
            await this.initialize();
          } catch (e) {
            console.log(e);
            Swal.fire("Błąd", e.response.data.message.toString(), "error");
          }
        }
      });
    },
    async infoBonus(id) {
      await this.toggleLoading(true);
      try {
        const bonus = await axios({
          method: "get",
          url: process.env.VUE_APP_ROOT_API + "bonuses/details/" + id,
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        });
        this.bonus = bonus.data.data;
        this.currentBonusId = bonus.data.data.id;
        this.bonus.driverId = bonus.data.data.driver.id;
        this.originalStatus = bonus.data.data.status;
        delete bonus.data.data.driver;
        this.bonus.date = dayjs(bonus.data.data.date).format("YYYY-MM-DD");
        this.bonus.price = bonus.data.data.price / 100;
        this.dialog = true;
        await this.toggleLoading(false);
      } catch (e) {
        await this.toggleLoading(false);
        console.log(e);
        Swal.fire("Błąd", e.response.data.message.toString(), "error");
      }
    },
    async submitBonus() {
      // Process the bonus data here
      try {
        const formData = new FormData();
      try {
        formData.append("file", this.bonus.file, this.bonus.file.name);
      } catch (e) {
        console.log("Missing Image");
      }
        formData.append("date", this.bonus.date);
        formData.append("name", this.bonus.name);
        formData.append("type", this.bonus.type);
        formData.append("driverId", this.bonus.driverId);
        formData.append("status", this.bonus.status);
        formData.append("price", this.bonus.price);
        formData.append("id", this.currentBonusId || undefined);
        await this.toggleLoading(true);
        await axios({
          method: "post",
          url: process.env.VUE_APP_ROOT_API + "bonuses",
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
            "Content-Type": "multipart/form-data",
          },
          data: formData,
        });
        this.closeDialog();
        await this.toggleLoading(false);
        await this.initialize();
      } catch (e) {
        await this.toggleLoading(false);
        console.log(e);
        Swal.fire("Błąd", e.response.data.message.toString(), "error");
      }
    },
    async initialize() {
      this.loading = true;
      if (this.search.trim().length > 0) {
        this.options.page = 1;
      }
      try {
        let url = process.env.VUE_APP_ROOT_API +
          `bonuses/all?take=${this.options.itemsPerPage}&skip=${this.options.page}&search=${this.search}`;

        if (this.startDate) {
          url += `&startDate=${this.startDate}`;
        }
        if (this.endDate) {
          url += `&endDate=${this.endDate}`;
        }
        if (this.selectedDriver) {
          url += `&driverId=${this.selectedDriver}`;
        }

        const bonuses = await axios({
          method: "get",
          url: url,
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        });
        this.bonuses = bonuses.data.data.result.map((bonus) => {
          return {
            price: bonus.price / 100,
            type: bonus.type,
            driver: bonus.driver.firstName + " " + bonus.driver.lastName,
            driverId: bonus.driver?.id,
            status: bonus.status,
            date: dayjs(bonus.date).format("DD-MM-YYYY"),
            fileId: bonus.file.length > 0 ? bonus.file[0]?.id : null,
            description: bonus.name,
            id: bonus.id,
          };
        });
        this.totalItems = bonuses.data.data.count;
      } catch (e) {
        console.log(e);
        Swal.fire("Błąd", e.response.data.message.toString(), "error");
      }
      this.loading = false;
    },
    async getDriversSelect() {
      await this.toggleLoading(true);
      try {
        const drivers = await axios({
          method: "get",
          url: process.env.VUE_APP_ROOT_API + `drivers?take=100000&skip=1`,
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        });
        this.drivers = drivers.data.data.result.map((it) => {
          return {
            id: it.id,
            name: `${it.firstName} ${it.lastName}`,
          };
        });
      } catch (e) {
        console.log(e);
        Swal.fire("Błąd", e.response.data.message.toString(), "error");
      }
      await this.toggleLoading(false);
    },
    closeDialog() {
      this.dialog = false;
      this.currentBonusId = undefined;
      this.bonus.file = null;
      this.$refs.form.resetValidation(); // Reset form validation
    },
  },
};
</script>

<style scoped>
.bonus-page {
  margin: -24px;
  padding: 24px;
  background: #181C28;
  min-height: calc(100vh - 64px);
  color: #E6EAF2;
}
.page-header {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  margin-bottom: 20px;
}
.page-eyebrow {
  font-size: 11px;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: #5478FF;
  font-weight: 600;
}
.page-title {
  font-size: 28px;
  font-weight: 700;
  margin: 4px 0 0 0;
  color: #FFFFFF;
}
.table-section-title {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 16px 20px;
  border-bottom: 1px solid #2A3142;
}
.filter-icon {
  width: 32px;
  height: 32px;
  border-radius: 8px;
  background: rgba(84, 120, 255, 0.12);
  display: flex;
  align-items: center;
  justify-content: center;
}
.filter-title {
  font-size: 15px;
  font-weight: 600;
  color: #E6EAF2;
}
.action-pill {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 14px;
  border-radius: 999px;
  font-size: 13px;
  font-weight: 600;
  border: 1px solid transparent;
  cursor: pointer;
  transition: all 0.15s ease;
}
.action-pill--primary { background: #5478FF; color: #FFFFFF; }
.action-pill--primary:hover { background: #3F62E8; }
.bonus-page >>> .v-data-table {
  background: #232838 !important;
  color: #E6EAF2 !important;
  border-radius: 12px;
  border: 1px solid #2A3142;
}
.bonus-page >>> .v-data-table thead tr th {
  background: #1F2433 !important;
  color: #94A0B8 !important;
  border-bottom: 1px solid #2A3142 !important;
}
.bonus-page >>> .v-data-table tbody tr td {
  border-bottom: 1px solid #2A3142 !important;
  color: #E6EAF2 !important;
}
.bonus-page >>> .v-data-table tbody tr:hover {
  background: rgba(84, 120, 255, 0.06) !important;
}
.bonus-page >>> .v-text-field--outlined fieldset {
  border-color: #2A3142 !important;
}
.bonus-page >>> .v-text-field input,
.bonus-page >>> .v-text-field textarea,
.bonus-page >>> .v-select__selection {
  color: #E6EAF2 !important;
}
.bonus-page >>> .v-label {
  color: #94A0B8 !important;
}
.bonus-page >>> .v-dialog .v-card {
  background: #232838 !important;
  color: #E6EAF2 !important;
}
.bonus-page >>> .v-card__title,
.bonus-page >>> .v-card__text {
  color: #E6EAF2 !important;
}
</style>
